"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterceptFunctions = exports.trajectoryInfo = exports.projectileGravity = exports.StaticShot = exports.ShotFactory = exports.Shot = void 0;
var shot_1 = require("./shot");
Object.defineProperty(exports, "Shot", { enumerable: true, get: function () { return shot_1.Shot; } });
var shotFactory_1 = require("./shotFactory");
Object.defineProperty(exports, "ShotFactory", { enumerable: true, get: function () { return shotFactory_1.ShotFactory; } });
var staticShot_1 = require("./staticShot");
Object.defineProperty(exports, "StaticShot", { enumerable: true, get: function () { return staticShot_1.StaticShot; } });
var constants_1 = require("./calc/constants");
Object.defineProperty(exports, "projectileGravity", { enumerable: true, get: function () { return constants_1.projectileGravity; } });
Object.defineProperty(exports, "trajectoryInfo", { enumerable: true, get: function () { return constants_1.trajectoryInfo; } });
var mineflayer_util_plugin_1 = require("@nxg-org/mineflayer-util-plugin"); //I feel like this is bad behavior?
Object.defineProperty(exports, "InterceptFunctions", { enumerable: true, get: function () { return mineflayer_util_plugin_1.InterceptFunctions; } });
